import { ChartMode } from '../types';
import ResponsiveChartWrapper from '../ResponsiveChartWrapper';
import { useCurrentUrl } from '../../../utils/routing';
import {
  TopPathsChartList,
  TopPathsChartListOverflow,
} from './TopPathsChartUI';

interface IProps {
  analysisId: string;
  mode: ChartMode;
}

export const TopPathsChartWrapper = ({
  children,
  mode,
  analysisId,
}: React.PropsWithChildren<IProps>) => {
  const { isDashboardInUrl } = useCurrentUrl();
  return (
    <>
      {isDashboardInUrl ? (
        <ResponsiveChartWrapper analysisId={analysisId} mode={mode}>
          <TopPathsChartListOverflow>{children}</TopPathsChartListOverflow>
        </ResponsiveChartWrapper>
      ) : (
        <TopPathsChartList>{children}</TopPathsChartList>
      )}
    </>
  );
};
